module.exports = __webpack_public_path__ + "static/img/gali.b3a6dbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/gali.jpg
// module id = zQY3
// module chunks = 1